<div class="container m-b-10 layout-row layout-lt-md-column align-end gap-1percent">
  <button mat-raised-button color="primary" class="m-r-10" [routerLink]="['/system', 'roles-and-permissions']">
    <fa-icon icon="check" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Permissions' | translate }}
  </button>
  <button mat-raised-button color="primary" class="m-r-10" (click)="changeUserPassword()">
    <fa-icon icon="cog" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Change Password' | translate }}
  </button>
</div>
<div class="container layout-column gap-1percent">
  <mat-card>
    <div class="layout-row-wrap">
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.Tenant Id' | translate }}
        </div>
        <div>
          {{ tenantIdentifier }}
        </div>
      </div>
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.User Id' | translate }}
        </div>
        <div>
          {{ profileData.userId }}
        </div>
      </div>
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.User Name' | translate }}
        </div>
        <div>
          {{ profileData.username }}
        </div>
      </div>
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.Office' | translate }}
        </div>
        <div>
          {{ profileData.officeName }}
        </div>
      </div>
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.Status' | translate }}
        </div>
        <div>
          {{ profileData.authenticated ? 'Authenticated' : 'Not Authenticated' }}
        </div>
      </div>
      <div class="info-box">
        <div class="header">
          {{ 'labels.inputs.Language' | translate }}
        </div>
        <div>
          {{ language }}
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card>
    <table class="mat-elevation-z1" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'labels.inputs.Role' | translate }}
        </th>
        <td mat-cell *matCellDef="let role">
          {{ role.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'labels.inputs.Description' | translate }}
        </th>
        <td mat-cell *matCellDef="let role">
          {{ role.description }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
</div>
